import { RBAC_LINKS } from 'core/services/RBAC'
import { getRoleForAuth } from 'core/services/Storage'
import { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { Sidebar as SideBar, Nav, Sidenav } from 'rsuite'
import clsx from 'clsx'
import logo from 'assets/icons/avatar.png'
import { User } from 'core/models/User'
import DashBoard from 'shared/Icons/SideBarIcons/DashBoard'
import Games from 'shared/Icons/SideBarIcons/Games'
import Moderator from 'shared/Icons/SideBarIcons/Moderator'
import Tournaments from 'shared/Icons/SideBarIcons/Tournaments'
import ChallengeIcon from 'shared/Icons/SideBarIcons/Challenges'
import Spaces from 'shared/Icons/SideBarIcons/Spaces'
import Wallet from 'shared/Icons/SideBarIcons/Wallet'
import ManageWallet from 'shared/Icons/SideBarIcons/ManageWallet'
import Queries from 'shared/Icons/SideBarIcons/Queries'
import Bytes from 'shared/Icons/SideBarIcons/Bytes'
import WebSliders from 'shared/Icons/SideBarIcons/WebSliders'
import Pin from 'shared/Icons/SideBarIcons/Pin'
import Store from 'shared/Icons/SideBarIcons/Store'
import Crown from 'shared/Icons/Crown'
import ProPassSettings from 'shared/Icons/SideBarIcons/ProPassSettings'

interface SidebarProps {
  user: User;
}

export default function Sidebar({ user }: SidebarProps) {

  const [expand, setExpand] = useState(true)
  const role = getRoleForAuth()

  useEffect(() => {
    if (window.innerWidth < 720) {
      setExpand(false)
    }
  }, [])

  const handleLinkClick = () => {
    if (window.innerWidth < 720 && expand) {
      setExpand(false)
    }
  }

  return (
    <SideBar
      width={expand ? 260 : 56}
      collapsible
      className={clsx('app-sidebar', !expand && 'collapsed')}
    >
      <Sidenav.Header className={clsx('sidebar-header', !expand && 'collapsed')}>
        <div className='sidebar-profile-container' >
          <div className="profile-image">
            <img
              src={user.media?.profileImg ?? logo}
              width={60}
              height={60}
              alt='Profile'
            />
          </div>
          <p className='user-name'>{user.name || user.userName || 'Hub User'}</p>
        </div>
      </Sidenav.Header>
      <Sidenav expanded={expand} defaultOpenKeys={[]} appearance="subtle" style={{ backgroundColor: '#001D33' }}>
        <Sidenav.Body>
          <Nav className='nav-item-wrapper'>
            {
              RBAC_LINKS.dashboardRoutes.includes(role) &&
              <Nav.Item
                id='dashboard'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/dashboard"
                icon={<DashBoard fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Dashboard
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.gameRoute.includes(role) &&
              <Nav.Item
                id='games'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/games"
                icon={<Games fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Games
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.moderatorRoute.includes(role) &&
              <Nav.Item
                id='moderators'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/moderators"
                icon={<Moderator fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Moderators
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.tournamentRoutes.includes(role) &&
              <Nav.Item
                id='tournaments'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/tournaments"
                icon={<Tournaments fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Tournaments
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.challengeRoutes.includes(role) &&
              <Nav.Item
                id='challenges'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/challenges"
                icon={<ChallengeIcon fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Challenges
                </p>
              </Nav.Item>
            }
            {/* {
              RBAC_LINKS.creatorRoutes.includes(role) &&
              <Nav.Item
                id='creators'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/creators"
                icon={<CreatorIcon fontSize={20} color='#ffffff' className='nav-icon' />}
              >
                <p className="nav-content">
                  Creators
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.brandEnquiryRoutes.includes(role) &&
              <Nav.Item
                id='brand_enquiry'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/brand/enquiry"
                icon={<CreatorIcon fontSize={20} color='#ffffff' className='nav-icon' />}
              >
                <p className="nav-content">
                  Brand Enquiry
                </p>
              </Nav.Item>
            } */}
            {
              RBAC_LINKS.spaceRoutes.includes(role) &&
              <Nav.Item
                id='spaces'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/spaces"
                icon={<Spaces fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Spaces
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.storeRoutes.includes(role) &&
              <Nav.Item
                id='store'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/store"
                icon={<Store fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Store
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.walletRoutes.includes(role) &&
              <Nav.Item
                id='admin_wallet'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/admin-wallet"
                icon={<Wallet fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Wallet
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.walletRoutes.includes(role) &&
              <Nav.Item
                id='wallet'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/wallet"
                icon={<ManageWallet fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Manage Wallet
                </p>
              </Nav.Item>
            }
            {/* {
              RBAC_LINKS.pushNotificationRoutes.includes(role) &&
              <Nav.Item
                id='push_notification'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/push-notification"
                icon={<UserAdd fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Push Notification
                </p>
              </Nav.Item>
            } */}
            {
              RBAC_LINKS.userAccessRoutes.includes(role) &&
              <Nav.Item
                id='user_access_request'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/user/access-request"
                icon={<Queries fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Queries
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.webSliderRoutes.includes(role) &&
              <Nav.Item
                id='slider'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/slider"
                icon={<WebSliders fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Web Slider
                </p>
              </Nav.Item>
            }
            {/* {
              RBAC_LINKS.xoShopRoutes.includes(role) &&
              <Nav.Item
                id='xo_shop'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/xo-shop"
                icon={<ShopingCart fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Shop
                </p>
              </Nav.Item>
            } */}
            {/* {
              RBAC_LINKS.advertisementRoutes.includes(role) &&
              <Nav.Item
                id='advertisements'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/advertisements"
                icon={<TeleVisionAds fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Advertisements
                </p>
              </Nav.Item>
            } */}
            {
              RBAC_LINKS.shortsRoutes.includes(role) &&
              <Nav.Item
                id='shorts'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/shorts"
                icon={<Bytes fontSize={20} className='nav-icon shorts' />}
              >
                <p className="nav-content">
                  Bytes
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.pinnedRoutes.includes(role) &&
              <Nav.Item
                id='pinned'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/pinned"
                icon={<Pin fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Pins
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.provisionalTournamentsRoute.includes(role) &&
              <Nav.Item
                id='provisional_tournaments'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/provisional-tournaments"
                icon={<Tournaments fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Tournament Requests
                </p>
              </Nav.Item>
            }
            {
  RBAC_LINKS.spaceApprovalRoutes.includes(role) &&
  <Nav.Item
    id='space_approval'
    onSelect={handleLinkClick}
    as={NavLink}
    activeClassName="active"
    to="/space-approval"
    icon={<Spaces fontSize={20} className='nav-icon' />}
  >
    <p className="nav-content">
      Space Requests
    </p>
  </Nav.Item>
}

            {/* {
              RBAC_LINKS.gameStoreRoute.includes(role) &&
              <Nav.Item
                id='game_store'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/game-store"
                icon={<Trophy fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Game Store
                </p>
              </Nav.Item>
            } */}
            {
              RBAC_LINKS.proPassRoutes.includes(role) &&
              <Nav.Item
                id='pro_pass_users'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/pro-pass/users"
                icon={<Crown fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Pro Pass Users
                </p>
              </Nav.Item>
            }
            {
              RBAC_LINKS.proPassRoutes.includes(role) &&
              <Nav.Item
                id='pro_pass_settings'
                onSelect={handleLinkClick}
                as={NavLink}
                activeClassName="active"
                to="/pro-pass/settings"
                icon={<ProPassSettings fontSize={20} className='nav-icon' />}
              >
                <p className="nav-content">
                  Pro Pass Settings
                </p>
              </Nav.Item>
            }
          </Nav>
        </Sidenav.Body>
      </Sidenav>
    </SideBar >
  );
}
